var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":true,"max-width":"500px"},on:{"click:outside":_vm.close}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('filters')))]),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t('selectAvailableFilter')))]),_c('FilterList',{staticClass:"px-5 pb-3",attrs:{"filters":_vm.filters},on:{"filterSelected":_vm.selectFilter}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }